import React from 'react';
import { Switch, Route } from 'react-router-dom';
import VerifyEmail from './verify-email/VerifyEmail';
import { RegisterForm } from './form/RegisterForm.loadable';
import LinkExpired from './email-verified/LinkExpired';
import LinkAlreadyUsed from './email-verified/LinkAlreadyUsed';
import {
	ROUTE_VERIFY_EMAIL,
	ROUTE_LINK_ALREADY_USED,
	ROUTE_LINK_EXPIRED,
} from '../../../constants/Routes';

export default () => (
	<Switch>
		<Route exact path={ROUTE_VERIFY_EMAIL} component={VerifyEmail} />
		<Route exact path={ROUTE_LINK_ALREADY_USED} component={LinkAlreadyUsed} />
		<Route exact path={ROUTE_LINK_EXPIRED} component={LinkExpired} />
		<Route component={RegisterForm} />
	</Switch>
);
